export default __webpack_public_path__ + "948b55c8796aa4e4578142fc3cf1e8c1.png";